import { createSlice } from "@reduxjs/toolkit";

interface UserInfo {
  id: string;
  email: string;
  super_admin: boolean;
  [key: string]: any;
}

interface AuthState {
  accessToken: string | null;
  emailFromOtp: string;
  refreshToken: string | null;
  superAdmin: boolean;
  user: UserInfo | null;
}

const initialState: AuthState = {
  accessToken: null,
  emailFromOtp: "",
  refreshToken: null,
  superAdmin: false,
  user: null,
};

const adminLoginSlice = createSlice({
  name: "loginTokken",
  initialState,
  reducers: {
    logoutAction: (): AuthState => initialState,
    accessAdminTokken(state, action) {
      state.accessToken = action.payload;
    },
    getEmailforOtp(state, action) {
      if (action.payload) {
        state.emailFromOtp = action.payload;
      }
    },
    accessRefreshToken(state, action) {
      if (action.payload) {
        state.refreshToken = action.payload;
      }
    },
    setUserInfo(state, action) {
      if (action.payload) {
        state.user = action.payload;
        state.superAdmin = action.payload.super_admin;
      }
    },
  },
});
export const {
  accessAdminTokken,
  logoutAction,
  getEmailforOtp,
  accessRefreshToken,
  setUserInfo,
} = adminLoginSlice.actions;
export default adminLoginSlice.reducer;
